import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import OAuthCallback from './pages/OAuthCallback';
import FooterNav from './components/FooterNav';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import MyFile from './pages/MyFile';
import GenerateWithAI from './pages/GenerateWithAI';
import PublishWithAI from './pages/PublishWithAI';
import Settings from './pages/Settings';
import CatalogManagement from './pages/CatalogManagement';
import PasswordReset from './pages/PasswordReset';
import { useTheme } from './contexts/ThemeContext';

const App: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isDark } = useTheme();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        // Close sidebar on ESC
        setSidebarOpen(false);
      }
      if (e.ctrlKey && (e.key === 'z' || e.key === 'Z')) {
        if (e.shiftKey) {
          // Ctrl+Shift+Z -> redo (forward)
          e.preventDefault();
          window.history.forward();
        } else {
          // Ctrl+Z -> undo (back)
          e.preventDefault();
          window.history.back();
        }
      } else if (e.ctrlKey && (e.key === 'y' || e.key === 'Y')) {
        // Ctrl+Y -> redo (forward)
        e.preventDefault();
        window.history.forward();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <Router>
      <div className={`min-h-screen transition-colors duration-300 ${
        isDark ? 'bg-slate-900' : 'bg-gray-50'
      }`}>
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main className="pb-20">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/my-file" element={<MyFile />} />
              <Route path="/generate" element={<GenerateWithAI />} />
              <Route path="/publish" element={<PublishWithAI />} />
              <Route path="/catalog" element={<CatalogManagement />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/reset-password" element={<PasswordReset />} />
              <Route path="/oauth/callback/:platform" element={<OAuthCallback />} />
            </Routes>
          </AnimatePresence>
        </main>

        <FooterNav />

        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
      </div>
    </Router>
  );
};

export default App;
